import type { ReactNode } from 'react'
import React from 'react'
import { color, csx, cx } from '@vtex/admin-ui'

export type IndicatorValueProps = {
  className?: string
  children: ReactNode
}

export const IndicatorValue = ({
  className = '',
  ...props
}: IndicatorValueProps) => (
  <div
    className={cx(
      csx({
        text: '$title1',
        color: color('$blue40'),
      }),
      className
    )}
    {...props}
  />
)
